var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body fill-height"},[_c('h1',[_vm._v("404")]),_c('p',[_vm._v("Oops! Something is wrong.")]),_c('a',{staticClass:"button",attrs:{"href":"/"}},[_c('i',{staticClass:"icon-home"}),_vm._v(" Go back to home page. ")])])
}]

export { render, staticRenderFns }